export default __webpack_public_path__ + "static/media/guardian.b0b24817.png";